import { render, staticRenderFns } from "./secondNav.vue?vue&type=template&id=06bb6f7a&scoped=true&"
import script from "./secondNav.vue?vue&type=script&lang=js&"
export * from "./secondNav.vue?vue&type=script&lang=js&"
import style0 from "./secondNav.vue?vue&type=style&index=0&id=06bb6f7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bb6f7a",
  null
  
)

export default component.exports